<template>
   <div class="row">
        <div class="card col-12">
           <div class="card-header">
             <h3 class="title">{{ $t('import_farmers') }}</h3>
           </div>
           <div class="card-body">
               <div class="row">
                   <div class="col-md-8 offset-md-2">
                       <form @submit.prevent="saveFarmersImportData">
                            <ValidationProvider name="email" rules="required|min:3" v-slot="{ errors }">
                                <fg-input :error="errors[0]" 
                                    v-model="form.email" 
                                    :placeholder="$t('email')" 
                                    required
                                    :label="$t('email')"></fg-input>
                            </ValidationProvider>
                            <div>
                                <label for="backgroundImage">{{ $t('farmers_data') }}</label>
                                <input
                                    id="backgroundImage"
                                    class="form-control"
                                    required
                                    type="file"
                                    @change="setPageImage($event)"
                                />
                            </div>
                            <div style="margin-top: 30px;">
                                <button type="submit" class="btn btn-info btn-block" v-loading="saving" element-loading-text="Saving data...">
                                    Save
                                </button>
                            </div>
                       </form>
                   </div>
               </div>
           </div>
           <div class="card-footer"></div>
        </div>
   </div>
</template>
<script>
import Resource from "@/util/Api/resource.js";
const ImportFarmers = new Resource("import/farmers");

export default {
    data() {
        return {
            saving: false,
            loading: false,
            form: {
                email: "",
                farmers_data: ""
            }
        }
    },

    methods: {

        showAlertMessage(message, type) {
            this.$message.closeAll();
            this.$message({ type: type,  message: message  });
        },

        async setPageImage($event) {
            let file = $event.target.files[0];
            if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                this.form.farmers_data = file;
            } else {
                this.form.farmers_data = "";
                this.showAlertMessage(this.$t("file_format_not_supported_supported_file_types_are_jpg_jpeg_png"), "error");
            }
        },

        async saveFarmersImportData() {
            let formData = new FormData();

            formData.append('email', this.form.email);
            formData.append('farmers_data', this.form.farmers_data);

            this.saving = true;

            await ImportFarmers.store(formData)
            .then(res => {
                this.saving = false;
                this.showAlertMessage(this.$t("import_successful"), "success");
            }).catch(error => {
                this.saving = false;
                this.showAlertMessage(error.response.data.errors, "error");
            });
        }

    },  
}
</script>